import React from "react";
import intl from "react-intl-universal";
import { mdiCheck, mdiClose } from "@mdi/js";

import { Text } from "./Text";
import { Spacer } from "./Spacer";
import { Button } from "./Button";
import { Dialog } from "../containers/Dialog";
import { DialogBody } from "../containers/DialogBody";
import { DialogFooter } from "../containers/DialogFooter";

export const Confirm = props => {

    const { title, body, confirm, confirmButtonOnly } = props;

    return (
        <Dialog
            width="415px"
            title={title}
            onClose={() => props.onClose()}>
            <DialogBody>
                <Text size="medium">{body}</Text>
            </DialogBody>
            <DialogFooter>
                <Button
                    id="confirmButton"
                    svgIcon={mdiCheck}
                    value={confirm}
                    onClick={() => props.onConfirm()} />
                {!confirmButtonOnly &&
                    <>
                        <Spacer size="small" variant="vertical" />
                        <Button
                            svgIcon={mdiClose}
                            onClick={() => props.onClose()}
                            value={intl.get("common.cancel")} />
                    </>
                }
            </DialogFooter>
        </Dialog>
    );
};